export default "__VITE_ASSET__6e93dfb2__"